// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4992) return "static/chunks/4992-8da82250c804d6c1.js";
	if (chunkId === 9839) return "static/chunks/9839-457cd7c680de2fea.js";
	if (chunkId === 3466) return "static/chunks/3466-7aeedbc5b54944a8.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3524 ? "2170a4aa" : chunkId) + "." + {"2745":"3579cf54946db53b","3506":"9730132042e17e7a","3524":"b01f5c7bdea775fb","8436":"cab94b59cca0a8ff"}[chunkId] + ".js";
};